import React, { useEffect, useState } from "react";
import Toggle from "./Toggles";
import { apiClient } from "../services/apiClient";

export default function SubcategoryFetcher({ categoryId }) {
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    const fetchSubCategories = async () => {
      if (!categoryId) return;
      try {
        const subCategoryData = await apiClient.get("/subcat/", {
          params: {
            category__firm: 3,
            category: categoryId,
            is_active: true,
          },
        });
        setSubCategories(subCategoryData);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    };

    fetchSubCategories();
  }, [categoryId]);

  return <Toggle items={subCategories} />;
}
